import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=628a0c52&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/all-admin.css?vue&type=style&index=0&id=628a0c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a0c52",
  null
  
)

export default component.exports